import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/VariaveisGlobais.css";


Vue.config.productionTip = false

document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 
// 02146450000112

//
// baitnazha
// 29.274.029/0001-43     29274029000143